const Events = {
  SHOW_CREATE_THREAD_POPUP: "show-create-thread-popup",
  SHOW_TWILIO_SANDBOX_WARNING: "show-twilio-sandbox-warning",
  HIDE_CREATE_THREAD_POPUP: "hide-create-thread-popup",
  HIDE_TWILIO_SANDBOX_WARNING: "hide-twilio-sandbox-warning",
  SHOW_QR_CODE_POPUP: "SHOW_QR_CODE_POPUP",
  HIDE_QR_CODE_POPUP: "HIDE_QR_CODE_POPUP",
  SHOW_CSV_ROOM_IMPORT_POPUP: "SHOW_CSV_ROOM_IMPORT_POPUP",
  HIDE_CSV_ROOM_IMPORT_POPUP: "HIDE_CSV_ROOM_IMPORT_POPUP",
  SHOW_THREAD_CHAT_MODAL: "SHOW_THREAD_CHAT_MODAL",
  HIDE_THREAD_CHAT_MODAL: "HIDE_THREAD_CHAT_MODAL",
  SHOW_ADD_CONTACT_MODAL: "SHOW_ADD_CONTACT_MODAL",
};

export default Events;
